import PropTypes from 'prop-types';
import PaymentMethodImageCard from '../payment-method-image-card';
import classNames from 'classnames';

const PaymentMethodImagesStack = ({
   soredMethodsList,
   isCryptoCurrency,
   isNextApp,
}) => {

   const marginLeftClassName = isCryptoCurrency ? 'ml-[-12px]' : 'ml-[-28px]'
   const visibleCount = isCryptoCurrency ? 3 : 2
   const hiddenCount = soredMethodsList.length - visibleCount
   const visibleMethods = soredMethodsList.slice(0, visibleCount);


   return (
      <div
         className='relative flex items-center'
      >
         {
            visibleMethods.map((item, index) => {

               return (
                  <PaymentMethodImageCard
                     key={ isCryptoCurrency ? item.value : item.type }
                     cardWidth={ isCryptoCurrency ? 32 : 68 }
                     methodType={ isCryptoCurrency ? item.value : item.type }
                     wrapperClassName={ classNames({
                        'h-8 !p-1 !rounded-[4px]': true,
                        [`${ marginLeftClassName }`]: 0 !== index,
                     }) }
                     isCryptoCurrency={ isCryptoCurrency }
                     showSeeAll={ false }
                     isHideHoverEffect
                     isNextApp={ isNextApp }
                  />
               )
            })
         }
         {
            hiddenCount > 0 && (
               <PaymentMethodImageCard
                  cardWidth={ isCryptoCurrency ? 32 : 68 }
                  isHiddenCountItem
                  hiddenCount={ hiddenCount }
                  wrapperClassName={ `h-8 !p-1 !rounded-[4px] ${ marginLeftClassName }` }
                  showSeeAll={ false }
                  isHideHoverEffect
                  isNextApp={ isNextApp }
               />
            )
         }
      </div>
   )
}

PaymentMethodImagesStack.propTypes = {
   soredMethodsList: PropTypes.array,
   isCryptoCurrency: PropTypes.bool,
   isNextApp: PropTypes.bool,
}

export default PaymentMethodImagesStack;
